<template>
  <textarea
    ref="textarea"
    v-model="singleEditInfo"
    class="resize-none"
    :placeholder="$t('opinion')"
    :maxlength="
      currentAnswerConfig.isLimitCount ? currentAnswerConfig.maxCount : 999
    "
    rows="3"
    cols="3"
  />
</template>
<script setup>
import { useTextareaAutosize } from "@vueuse/core";
import answerHook from "@/hooks/answerHook";
const { singleEditInfo, currentAnswerConfig } = answerHook();
const { textarea, input } = useTextareaAutosize();
</script>

<style lang="scss" scoped>
.resize-none {
  resize: none;
  width: 100%;
  min-height: 150px;
  border: none;
  outline: none;
  padding: 20px 0 0 25px;
  box-sizing: border-box;
  border-radius: 15px;
  box-shadow: 0 0 8px #ccc;
  font-size: 22px;
  @media (orientation: landscape) {
    min-height: 150px;
    box-shadow: 0 0 8px #ccc;

    padding: 20px 0 0 25px;
    border-radius: 15px;
    font-size: 22px;
  }
}
</style>
